import { DatasetProperty } from './dataset-records';
export const toDatasetProperty = (tableName, snowflakeProperty) => {
  return DatasetProperty({
    name: snowflakeProperty.name,
    table: tableName,
    type: snowflakeProperty.type
  });
};